<template>
    <div class="header">
        <div class="pre-actions">
            <ActionButton
                @click="onActionClose()"
                :class="close_class"
                :icon="icons[close_class]"
                v-tooltip='"global.actions.back"'
            />
        </div>

        <h2 class="title">
            {{Language.say(title)}}
        </h2>

        <div class="actions" v-if="content_state.loaded === true">
            <slot name="actions"> </slot>
            <slot name="actions_over"> </slot>
        </div>
    </div>

    <slot name="pre_content"  v-if="content_state.loaded === true"></slot>

    <main :class='content_class' class="content" v-smart-render-scroll>
        <slot v-if="content_state.loaded === true"
          name="content"
        >
        </slot>

        <ContentSaving v-if="content_state.saving"
        />

        <ContentLoading v-if="content_state.loading"
        />

        <ContentError v-if="content_state.error"
          @contentErrorRetry="onErrorRetry"
        />

        <ContentEmpty v-if="content_state.not_found" />
    </main>

    <slot name="footer"></slot>
</template>

<script setup>
  import {defineProps, defineEmits} from "vue";
  import router                     from "@/vue/router";
  import ActionButton               from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContentSaving              from "@/vue/Elements/Content/ContentSaving.vue";
  import ContentLoading             from '@/vue/Elements/Content/ContentLoading.vue';
  import ContentError               from '@/vue/Elements/Content/ContentError.vue';
  import ContentEmpty               from '@/vue/Elements/Content/ContentEmpty.vue';
  import Language                   from '@/js/Shared/Language/Language.js';

  const emit = defineEmits([
    'actionClose'
  ])

  const props = defineProps({
    title : {
      default : ''
    },

    close_class : {
      default : 'back',
    },

    close_route : {
      default : null,
    },

    content_state : {
      required : true,
    },

    content_class : {
      default: '',
    },
  })

  const icons = {
    'close' : 'fas fa-times-circle',
    'back'  : 'fas fa-chevron-circle-left',
  }

  const onErrorRetry = () => {
    props.content_state.errorRetry();
  }

  const onActionClose = () => {
    emit('actionClose');

    if (props.close_route) {
      router.push({name: props.close_route});
      return;
    }
  };

</script>
